//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CharacteristicBox from '../CharacteristicBox'

export default {
  components: {
    CharacteristicBox,
  },
  props: {
    characteristics: {
      type: Array,
      required: true,
    },
  },
}
